import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=09f18765&"
import script from "./CompanyCard.vue?vue&type=script&lang=js&"
export * from "./CompanyCard.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CompanyCard.vue?vue&type=style&index=0&id=09f18765&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./CompanyCard.vue?vue&type=style&index=1&id=09f18765&prod&lang=scss&")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports